var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLambda(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 124,
    width: 80,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-551 -124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551 124 631 124 631 204 551 204Z",
    fill: "#ED7100",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.008 190 566.591 190 580.324 161.296 586.546 174.106 579.008 190ZM581.22 158.553C581.051 158.208 580.701 157.989 580.318 157.989L580.315 157.989C579.929 157.99 579.578 158.211 579.412 158.558L564.098 190.569C563.95 190.879 563.971 191.243 564.155 191.534 564.338 191.824 564.658 192 565.002 192L579.642 192C580.03 192 580.382 191.777 580.548 191.428L588.564 174.528C588.693 174.254 588.692 173.937 588.559 173.665L581.22 158.553ZM615.995 190 603.659 190 583.867 148.57C583.701 148.222 583.349 148 582.962 148L574.89 148 574.899 138 590.72 138 610.42 179.429C610.586 179.777 610.939 180 611.326 180L615.995 180 615.995 190ZM616.998 178 611.96 178 592.259 136.571C592.094 136.223 591.741 136 591.353 136L573.898 136C573.345 136 572.896 136.447 572.895 136.999L572.884 148.999C572.884 149.265 572.989 149.519 573.178 149.707 573.365 149.895 573.62 150 573.887 150L582.329 150 602.122 191.43C602.289 191.778 602.639 192 603.026 192L616.998 192C617.552 192 618 191.552 618 191L618 179C618 178.448 617.552 178 616.998 178L616.998 178Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLambda);
export default __webpack_public_path__ + "static/media/lambda.086d2af91e991fc3afb313bfa9522ebc.svg";
export { ForwardRef as ReactComponent };